<template>
  <div class="zs-page">
    <ZSButton v-if="backButton" @click="$emit('back')" class="back-button p-button-text gap-3 mt-1">
      <img src="@/assets/back_arrow.svg" alt="back" />
      {{ backButtonLabel }}</ZSButton>
      <slot name ="title">
        <div v-if="title.length > 0" class="title">{{ title }}</div>
      </slot>
      <div v-if="toolbar" class="zs-page-header">
        <slot name="toolbar">

        </slot>
      </div>
    <slot></slot>
    <ZSSCrolltop target="parent" :threshold="100" />
  </div>
</template>

<script setup>
 import { useZSToast } from "@/components/zs-components/toast/useToast";      
import { watch } from "vue";
import { useI18n } from "vue-i18n";


defineEmits(["back"]);
const toast = useZSToast();

const { t } = useI18n();

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  backButton: {
    type: Boolean,
    default: false,
  },
  backButtonLabel: {
    type: String,
    default: "voltar",
  },
  error: {
    type: Object,
    default: {},
  },
  toolbar:{
    type:Boolean,
    default:true
  }
});

watch(
  () => props.error,
  (val) => {
    if (val) {
      toast.add({
        type: "error",
        summary: "Error",
        detail: t(val?.i18n ?? "") ?? "Error",
        life: 6000,
      });
    }
  }
);
</script>

<style  scoped>
.zs-page {
  background-color: #fff;
  padding: 0 1em;
  max-height: calc(100vh - 10px);
  overflow: auto;

  /* .zs-page-header { */
    /* display: flex;
    justify-content: space-between; */
    /* align-items: center; */
    /* margin-bottom: 20px; */
  /* } */

  .title {
    font-size: 36px;
    font-weight: 500;
    color: #e84e0f;
    margin-bottom: 10px;
  }

  .back-button {
    font-size: 23px;
    color: black;
  }
}
</style>
